import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { DeliveryStoresStatusCSVGenerationJobService } from '@/services/StoreManagement/DeliveryStoresStatusCSVGenerationJob/DeliveryStoresStatusCSVGenerationJobService';

export type DeliveryStoresStatusCSVGenerationJobResponse = {
  id: string;
  status: 0 | 1 | 2 | 3;
  created_at: string;
};

export const useDeliveryStoresStatusCSVGenerationJobLatest =
  async (): Promise<DeliveryStoresStatusCSVGenerationJobResponse> => {
    const deliveryStoresStatusCSVGenerationJobService =
      new DeliveryStoresStatusCSVGenerationJobService(getClient());
    try {
      const res = await deliveryStoresStatusCSVGenerationJobService.latest();
      return res;
    } catch (error) {
      // @ts-ignore TS2322
      return errorHandler({ error });
    }
  };
